import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import Auth from "../Auth/Auth";

export const Home = () =>
{

    const publicWebUserData = Auth.getPublicWebUserData();
    const isSubscribed = Auth.isSubscribed();
    const isPromotioned = Auth.isPromotioned();
    const isOutdated = Auth.isLastPlanOutdated();

    const [publicDataUrl, setPublicDataUrl] = React.useState<string>("");

    useEffect(() => {
        if (publicWebUserData?.lastContractActive!) {
            setPublicDataUrl(`/accountHolder/${publicWebUserData.lastContractActive}`);
        }
    }, [publicWebUserData]);
    
    return (
        <React.Fragment>
            {isOutdated && <Redirect to="/savingsPlans"/>}
            {isSubscribed && <Redirect to="/portfolio"/>}
            {!isSubscribed && isPromotioned && <Redirect to="/promotioned"/>}
            {!isSubscribed && !isPromotioned && <Redirect to="/savingsPlans/new"/>}

            {/* usuarios que vienen del alta de usuario desde la web pública con Status 4000 */}
            {publicWebUserData?.status! && publicWebUserData?.lastContractActive! && <Redirect to={publicDataUrl}/>}

        </React.Fragment>
    );
};